// Engine API: agent runs.
// Backed by ~/Dev/seitiate/app/api/v1/agent_runs.py.

import { engineFetchJson } from '@/lib/engineHttp';
import type { AgentRunRead, CreateAgentRunBody } from './agentBoardTypes';

export async function createAgentRun(
  body: CreateAgentRunBody,
): Promise<AgentRunRead> {
  return engineFetchJson<AgentRunRead>('/agent-runs', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function getAgentRun(id: string): Promise<AgentRunRead> {
  return engineFetchJson<AgentRunRead>(
    `/agent-runs/${encodeURIComponent(id)}`,
  );
}

export interface UpdateAgentRunBody {
  status?: string;
  repo?: string;
  branch?: string;
  pr_url?: string;
  tests_status?: string;
  evidence_uri?: string;
  cost_actual?: number;
  cost_estimate?: number;
  halt_reason?: string;
  notes?: string;
  harness_workflow_id?: string;
}

export async function updateAgentRun(
  id: string,
  body: UpdateAgentRunBody,
): Promise<AgentRunRead> {
  return engineFetchJson<AgentRunRead>(
    `/agent-runs/${encodeURIComponent(id)}`,
    {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    },
  );
}
